/* eslint-disable import/no-mutable-exports */

const SITE =
  process.env.NEXT_PUBLIC_SITE ||
  globalThis.document?.body?.getAttribute('data-site') ||
  'TKR'

export const isTKR = SITE === 'TKR'
export const isLTC = SITE === 'LTC'

const embeddedApiPrefix = () => {
  if (!isLTC) return ''
  const prefixFromEnv =
    process.env.NEXT_PUBLIC_EMBEDDED_API_PREFIX ||
    globalThis.document?.body?.getAttribute('data-public-embedded-api-prefix')
  if (!prefixFromEnv) return prefixFromEnv

  // add a leading slash and trim all other leading or tailing slashes
  return `/${prefixFromEnv.replace(/^\/*/, '').replace(/\/*$/, '')}`
}

export const embeddedApiPrefixFromEnv = embeddedApiPrefix()

export const LOGIN_PAGE_URL = '/iaas/auth/login'
export let apiPrefix = ''
export let publicApiPrefix = ''

export const defaultLoginURL = isLTC ? LOGIN_PAGE_URL : '/signin'

// NEXT_PUBLIC_API_PREFIX=/console/api NEXT_PUBLIC_PUBLIC_API_PREFIX=/api npm run start
if (process.env.NEXT_PUBLIC_API_PREFIX && process.env.NEXT_PUBLIC_PUBLIC_API_PREFIX) {
  apiPrefix = process.env.NEXT_PUBLIC_API_PREFIX
  publicApiPrefix = process.env.NEXT_PUBLIC_PUBLIC_API_PREFIX
}
else if (
  globalThis.document?.body?.getAttribute('data-api-prefix')
  && globalThis.document?.body?.getAttribute('data-pubic-api-prefix')
) {
  // Not build can not get env from process.env.NEXT_PUBLIC_ in browser https://nextjs.org/docs/basic-features/environment-variables#exposing-environment-variables-to-the-browser
  apiPrefix = globalThis.document.body.getAttribute('data-api-prefix') as string
  publicApiPrefix = globalThis.document.body.getAttribute('data-pubic-api-prefix') as string
}
else {
  // const domainParts = globalThis.location?.host?.split('.');
  // in production env, the host is dify.app . In other env, the host is [dev].dify.app
  // const env = domainParts.length === 2 ? 'ai' : domainParts?.[0];
  apiPrefix = 'http://localhost:5001/console/api'
  publicApiPrefix = 'http://localhost:5001/api' // avoid browser private mode api cross origin
}

if (embeddedApiPrefixFromEnv) {
  apiPrefix = `${embeddedApiPrefix() || ''}/console/api`
  publicApiPrefix = `${embeddedApiPrefix() || ''}/api`
}

export const API_PREFIX: string = apiPrefix
export const PUBLIC_API_PREFIX: string = publicApiPrefix

const EDITION = process.env.NEXT_PUBLIC_EDITION || globalThis.document?.body?.getAttribute('data-public-edition') || 'SELF_HOSTED'
export const IS_CE_EDITION = EDITION === 'SELF_HOSTED'

export const SUPPORT_MAIL_LOGIN = !!(process.env.NEXT_PUBLIC_SUPPORT_MAIL_LOGIN || globalThis.document?.body?.getAttribute('data-public-support-mail-login'))

export const LOCALE_COOKIE_NAME = 'lang'

export const emailRegex = /^[\w\.-]+@([\w-]+\.)+[\w-]{2,}$/m
